export const OSC_CLICKID = {
  JOIN: 'gh_join',
  SIGNIN: 'gh_signin',
  BACKTOTOP: 'back_to_top',
} as const;
